import { Observable } from 'knockout';
import WCCEntity from './entity';

export interface JSONThreadVote {
    PersonId: string,
    ThreadId: string,
    VoteValue: number,
    LinkedThreadId: string
}

export default class ThreadVote extends WCCEntity<JSONThreadVote> {
    personId: Observable<string>
    threadId: Observable<string>
    value: Observable<number>
    linkedThreadId: Observable<string>

    constructor(json: JSONThreadVote) {
        super();

        this.personId = this.createField(json, 'PersonId');
        this.threadId = this.createField(json, 'ThreadId');
        this.value = this.createField(json, 'VoteValue', 0);
        this.linkedThreadId = this.createField(json, 'LinkedThreadId');
    }
}